module.exports = __webpack_public_path__ + "static/media/Spade.44772fbc.svg";